// #endregion

/**
 * User map service that does a mapping from email to a display name
 * {
 *   "test@example.com": "Lastname, FirstName"
 *   "gme@tothemon.com": "Cohen, Ryan"
 * }
 */
type User = UasUser & { _formatted: { [key: string]: string } };
class UserMap {
    users: User[] = [];
    // @ts-ignore TODO uas with cognito
    private displayName(user: UasUser) {
        const { FIRST_NAME, LAST_NAME } = user.attributes;
        if (FIRST_NAME && LAST_NAME) {
            return `${LAST_NAME}, ${FIRST_NAME}`;
        }
        if (!FIRST_NAME && LAST_NAME) return LAST_NAME;
        if (!LAST_NAME && FIRST_NAME) return FIRST_NAME;
        return user.userMappedId;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init(_a: UasUser[]) {
        // TODO first name last name needs to be redone with cognito
        // this.users = a.map((o) => {
        //     return {
        //         ...o,
        //         _formatted: {
        //             [o.userMappedId]: this.displayName(o)
        //         }
        //     };
        // });
    }

    getDisplayName(val: string) {
        // TODO first name last name needs to be redone with cognito
        return val;
        // return this.users?.find((o) => o?._formatted[val])?._formatted?.[val] ?? val;
    }
}

export const UserMapService = new UserMap();
